import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ProblemSection() {
  return <section className="py-16 md:py-[60px] px-4 bg-[#050505] border-y border-border" data-id="element-210">
      <motion.div className="max-w-[900px] mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-211">
        {/* Header */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-212">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-213">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-214"></span>
            El Problema Real
          </div>
          <h2 className="mb-4 font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-215">
            TU TERMOSTATO <span className="text-gold" data-id="element-216">FINANCIERO</span>
          </h2>
          <p className="text-[15px] leading-[1.7] text-text-secondary max-w-[600px]" data-id="element-217">
            El estancamiento financiero no tiene nada que ver con la economía,
            el algoritmo de Instagram o la falta de capital.{' '}
            <strong className="text-white" data-id="element-218">Es programación biológica.</strong>
          </p>
        </motion.div>

        {/* Two-column: Virus card + Image */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-219">
          <motion.div variants={itemVariants} className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-220">
            <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-221">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-222"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-223">
                🧠 El Virus Silencioso
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-text-card" data-id="element-224">
              Tu mente es una computadora de última generación. Pero en el fondo
              de tu código, hay un{' '}
              <strong className="text-white" data-id="element-225">
                virus que se instaló cuando tenías 6 años:
              </strong>
              <ul className="mt-4 flex flex-col gap-2" data-id="element-226">
                <li className="flex items-start gap-2" data-id="element-227">
                  <span className="shrink-0 font-bold text-gold" data-id="element-228">→</span>
                  "El dinero es peligroso"
                </li>
                <li className="flex items-start gap-2" data-id="element-229">
                  <span className="shrink-0 font-bold text-gold" data-id="element-230">→</span>
                  "Los ricos son gente mala"
                </li>
                <li className="flex items-start gap-2" data-id="element-231">
                  <span className="shrink-0 font-bold text-gold" data-id="element-232">→</span>
                  "Necesito que otros aprueben lo que hago para sentirme seguro"
                </li>
                <li className="flex items-start gap-2" data-id="element-233">
                  <span className="shrink-0 font-bold text-gold" data-id="element-234">→</span>
                  "Si no sufro, no lo merezco"
                </li>
                <li className="flex items-start gap-2" data-id="element-235">
                  <span className="shrink-0 font-bold text-gold" data-id="element-236">→</span>
                  "El dinero es difícil de conseguir"
                </li>
                <li className="flex items-start gap-2" data-id="element-237">
                  <span className="shrink-0 font-bold text-gold" data-id="element-238">→</span>
                  <strong className="text-white" data-id="element-239">"No soy suficiente"</strong>
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-240">
            <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-241">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-242"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-243">
                ⚠️ Protocolo de Sabotaje
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-text-card" data-id="element-244">
              Cada vez que te acercas a tu{' '}
              <strong className="text-gold" data-id="element-245">Zona de Seguridad</strong>, el virus
              se activa:
              <ul className="mt-4 flex flex-col gap-2" data-id="element-246">
                <li className="flex items-start gap-2" data-id="element-247">
                  <span className="shrink-0 font-bold text-[#f44336]" data-id="element-248">✕</span>
                  De repente, te enfermas
                </li>
                <li className="flex items-start gap-2" data-id="element-249">
                  <span className="shrink-0 font-bold text-[#f44336]" data-id="element-250">✕</span>
                  Se rompe el coche
                </li>
                <li className="flex items-start gap-2" data-id="element-251">
                  <span className="shrink-0 font-bold text-[#f44336]" data-id="element-252">✕</span>
                  Tomas una decisión de inversión estúpida
                </li>
                <li className="flex items-start gap-2" data-id="element-253">
                  <span className="shrink-0 font-bold text-[#f44336]" data-id="element-254">✕</span>
                  Procrastinas la llamada que iba a cambiarlo todo
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Image */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-255">
          <div className="overflow-hidden rounded-[10px] border-2 border-border" data-id="element-256">
            <img src="https://cdn.magicpatterns.com/uploads/6M3VcEVF3cMZZkN6ZH39QN/Imagen_Codigo_de_identidad-4.png" alt="Hombre de negocios reflexionando" className="w-full h-auto object-cover grayscale opacity-80 hover:grayscale-0 transition-all duration-500" data-id="element-257" />
          </div>
        </motion.div>

        {/* Pull quote */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-258">
          <div className="rounded-r-lg border border-border border-l-[3px] border-l-gold bg-surface-dark px-[22px] py-[20px]" data-id="element-259">
            <p className="text-[18px] md:text-[22px] font-black italic leading-[1.4] text-white" data-id="element-260">
              "No es mala suerte. Es tu termostato financiero."
            </p>
          </div>
        </motion.div>

        {/* Conditioning summary — compact two-column */}
        <motion.div variants={itemVariants} data-id="element-261">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-262">
            <div className="rounded-lg border border-border bg-surface px-[18px] py-[18px]" data-id="element-263">
              <div className="mb-2 font-heading text-[11px] font-black uppercase tracking-[1px] text-white" data-id="element-264">
                🔄 La Trampa del Subconsciente
              </div>
              <p className="text-[13px] leading-[1.75] text-text-card" data-id="element-265">
                Tu mente interpreta la riqueza como una{' '}
                <strong className="text-white" data-id="element-266">amenaza de muerte</strong> para
                tu identidad actual. Prefiere una miseria conocida que una
                abundancia desconocida.
              </p>
            </div>
            <div className="rounded-lg border border-border bg-surface px-[18px] py-[18px]" data-id="element-267">
              <div className="mb-2 font-heading text-[11px] font-black uppercase tracking-[1px] text-white" data-id="element-268">
                💀 Adicto al Esfuerzo Vacío
              </div>
              <p className="text-[13px] leading-[1.75] text-text-card" data-id="element-269">
                Trabajas 12 horas y sientes que "cumpliste", aunque no hayas
                ganado un dólar.{' '}
                <strong className="text-white" data-id="element-270">
                  Tu identidad se alimenta de la lucha, no del resultado.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}